import { Service } from '@angular/core';
import { ModuleType } from './models';

@Service()
export class ModuleRouteContextService {
    public getModuleTypeFromSlug(slug: string | null | undefined): ModuleType | null {
        switch (slug?.toLowerCase()) {
            case 'ex':
                return ModuleType.EmployeeExperience;
            case 'cx':
                return ModuleType.CustomerExperience;
            default:
                return null;
        }
    }

    public getSlugFromModuleType(moduleType: ModuleType | null | undefined): string | null {
        switch (moduleType) {
            case ModuleType.EmployeeExperience:
                return 'ex';
            case ModuleType.CustomerExperience:
                return 'cx';
            default:
                return null;
        }
    }
}
